import { API_TIMEOUT } from "Const"
import axios from "./axios"
/**
 * 簡易見積APIのリクエスト
 * @param {any} data - リクエスト用JSON
 * @return {object} - 簡易見積APIのレスポンス結果
 */
export default function getEstimation(data: any) {
  return axios
    .post("/easy_calc", data, API_TIMEOUT)
    .then((res: any) => {
      return res
    })
    .catch((err: any) => {
      return err
    })
}
